/* eslint-disable @typescript-eslint/camelcase */
import { ShopsActionType } from '../actions/shopsActions';
import ShopActions from './../actions/shopsActions';
import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import { Services } from '@card/commonlib';
import { Shop } from '@card/types';

type ShopsAction = {
  type: string;
  error: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  payload: any; // TODO payload type
  meta: undefined;
};

function* fetchShops() {
  try {
    const shops: Shop[] = yield call(Services.getShops);
    yield put(ShopActions.fetchSuccess(shops));
  } catch (error) {
    yield put(ShopActions.fetchError(error));
  }
}

// Podria mejorarse
function* saveShopsName(shopsAction: ShopsAction) {
  const promises: Promise<unknown>[] = [];
  shopsAction.payload.forEach((shop: Shop) => {
    const shopParams = {
      name: shop.name
    };
    if (shop.status === 'NEW') {
      promises.push(Services.createShop(shopParams));
    }
    if (shop.modified && shop.status !== 'NEW') {
      promises.push(Services.updateShop(shop.id, shopParams));
    }
  });
  try {
    yield Promise.all(promises);
    const shops: Shop[] = yield call(Services.getShops);
    yield put(ShopActions.fetchSuccess(shops));
  } catch (error) {
    const currentId = error.response.config.url.substr(
      error.response.config.url.search('shops/') + 6
    );
    yield put(
      ShopActions.updateShopError({
        error,
        id: currentId
      })
    );
  }
}

function* destroyShop(shopsAction: ShopsAction) {
  const currentId = shopsAction.payload.id;
  try {
    yield call(Services.destroyShop, currentId);
    yield put(ShopActions.fetch());
  } catch (error) {
    yield put(
      ShopActions.updateShopError({
        error,
        id: currentId
      })
    );
  }
}

function* shopsSagas() {
  yield takeEvery(ShopsActionType.Fetch, fetchShops);
  yield takeLatest(ShopsActionType.SaveShops, saveShopsName);
  yield takeLatest(ShopsActionType.DestroyShop, destroyShop);
}
export default shopsSagas;
